import React, { useContext } from "react";
import { ProjectsContext } from "../admin/ProjectsContext";
import { PieChart, Pie, Cell, ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend } from "recharts";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useEffect, useState } from "react";

export default function AdminDashboard() {
  const { projects } = useContext(ProjectsContext);
console.log("All projects:", projects);

  // Metrics
  const totalProjects = projects.length;
  const residentialCount = projects.filter(p => p.category === "residential").length;
  const farmlandCount = projects.filter(p => p.category === "farmland").length;

  // Mock bookings (replace with real data if available)
  // const totalBookings = 31;

  const [bookings, setBookings] = useState([]);
  const totalBookings = bookings.length;

useEffect(() => {
  const fetchBookings = async () => {
    try {
      const snapshot = await getDocs(collection(db, "siteVisitBookings"));

      console.log("Raw snapshot size:", snapshot.size);

      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      console.log("Fetched siteVisitBookings data:", data);
      setBookings(data);
    } catch (err) {
      console.error("Error fetching siteVisitBookings:", err);
    }
  };

  fetchBookings();
}, []);



  // Pie chart data
  const pieData = [
    { name: "Residential", value: residentialCount },
    { name: "Farmland", value: farmlandCount },
  ];

  const pieColors = ["var(--brand-gold)", "var(--brand-dark)"];

  // Bar chart data (count by status)
  const statusCounts = {};
  projects.forEach(p => {
    console.log("Project category:", p.category, "Status:", p.status);
    if (p.status) {
      statusCounts[p.status] = (statusCounts[p.status] || 0) + 1;
    }
  });
  const barData = Object.entries(statusCounts).map(([status, count]) => ({ status, count }));

  return (
    <div className="min-h-screen py-16" style={{ backgroundColor: "var(--bg-1)" }}>
      <div className="container-custom">

        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-brand-dark mb-4">Admin Dashboard</h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Overview of all Residential and Farmland projects, bookings, and statuses.
          </p>
        </div>

        {/* Metric Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-12">
          <div className="bg-white rounded-lg p-6 shadow card-hover text-center">
            <h3 className="text-lg text-gray-500 mb-2">Total Projects</h3>
            <p className="text-3xl font-bold text-brand-gold">{totalProjects}</p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow card-hover text-center">
            <h3 className="text-lg text-gray-500 mb-2">Residential Projects</h3>
            <p className="text-3xl font-bold text-brand-dark">{residentialCount}</p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow card-hover text-center">
            <h3 className="text-lg text-gray-500 mb-2">Farmland Projects</h3>
            <p className="text-3xl font-bold text-brand-dark">{farmlandCount}</p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow card-hover text-center">
            <h3 className="text-lg text-gray-500 mb-2">Total Bookings</h3>
            <p className="text-3xl font-bold text-brand-gold">{totalBookings}</p>
          </div>
        </div>

        {/* Charts */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Pie Chart */}
          <div className="bg-white rounded-lg p-6 shadow card-hover">
            <h3 className="text-xl font-semibold mb-4 text-center text-brand-dark">Residential vs Farmland</h3>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={pieData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={100}
                  fill="#8884d8"
                  label
                >
                  {pieData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={pieColors[index % pieColors.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>

          {/* Bar Chart */}
          <div className="bg-white rounded-lg p-6 shadow card-hover">
            <h3 className="text-xl font-semibold mb-4 text-center text-brand-dark">Projects by Status</h3>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={barData} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
                <XAxis dataKey="status" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="count" fill="var(--brand-gold)" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}